module.exports = __webpack_public_path__ + "img/juliang.dd5112e0.png";